import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';

import { appConfig } from '../config/appConfig';
import { useAuth } from '../context/AuthContext';
import { authService } from '../services/authService';
import { isValidChinaPhone, normalizePhoneNumber } from '../utils/authFormUtils';
import {
  FamilyCoBuildingPlanBadge,
  userHasFamilyCoBuildingIcon,
} from '../components/FamilyCoBuildingPlanBadge';

export function ProfilePage() {
  const { user, signOut, refreshProfile } = useAuth();
  const hasCoBuilding = userHasFamilyCoBuildingIcon(user);

  return (
    <div className="mx-auto max-w-lg space-y-6">
      <h1 className="text-2xl font-semibold text-ink">账户</h1>
      <div className="rounded-xl border border-border bg-surface p-5 shadow-card">
        {hasCoBuilding ? (
          <div className="mb-4 flex items-center gap-2 rounded-lg border border-primary/20 bg-primary/5 px-3 py-2 text-sm text-primary">
            <FamilyCoBuildingPlanBadge size={14} />
            <span className="font-medium">家庭共建计划</span>
          </div>
        ) : null}
        <dl className="space-y-3 text-sm">
          <div><dt className="text-muted">用户 ID</dt><dd className="font-mono text-ink">{user?.id}</dd></div>
          <div><dt className="text-muted">手机号</dt><dd className="text-ink">{user?.phone || '—'}</dd></div>
        </dl>
        <button type="button" onClick={() => void refreshProfile()} className="mt-4 text-sm text-primary">刷新资料</button>
      </div>

      <nav className="grid gap-2 text-sm">
        <Link to="/profile/password" className="rounded-lg border border-border px-4 py-3 hover:bg-canvas">修改密码</Link>
        <Link to="/profile/api-keys" className="rounded-lg border border-border px-4 py-3 hover:bg-canvas">API 密钥</Link>
        <Link to="/profile/models" className="rounded-lg border border-border px-4 py-3 hover:bg-canvas">模型配置</Link>
        <Link to="/review/sequence" className="rounded-lg border border-border px-4 py-3 hover:bg-canvas">学习序列</Link>
        <Link to="/settings/learning" className="rounded-lg border border-border px-4 py-3 hover:bg-canvas">学习设置</Link>
        <Link to="/about" className="rounded-lg border border-border px-4 py-3 hover:bg-canvas">关于 · {appConfig.icpWebsite}</Link>
      </nav>

      <div className="flex flex-wrap gap-3">
        <button type="button" onClick={() => void signOut()} className="rounded-lg border border-border px-4 py-2 text-sm">退出登录</button>
        <Link to="/profile/delete" className="rounded-lg border border-danger/30 px-4 py-2 text-sm text-danger">注销账号</Link>
      </div>
    </div>
  );
}

export function ChangePasswordPage() {
  const [phone, setPhone] = useState('');
  const [authCode, setAuthCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [token, setToken] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);

  async function handleVerify(event: FormEvent) {
    event.preventDefault();
    const normalized = normalizePhoneNumber(phone);
    const result = await authService.verifyPasswordChangeCode(normalized, authCode.trim());
    setToken(result.token);
    setMessage('验证码已通过，请设置新密码');
  }

  async function handleConfirm(event: FormEvent) {
    event.preventDefault();
    if (!token) return;
    const normalized = normalizePhoneNumber(phone);
    await authService.confirmPasswordChange(normalized, authCode.trim(), token, newPassword);
    setMessage('密码已更新，请重新登录');
  }

  return (
    <div className="mx-auto max-w-md space-y-4">
      <Link to="/profile" className="text-sm text-primary">← 账户</Link>
      <h1 className="text-2xl font-semibold text-ink">修改密码</h1>
      <form onSubmit={token ? handleConfirm : handleVerify} className="space-y-3 rounded-xl border border-border bg-surface p-5">
        <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="手机号" className="w-full rounded-lg border border-border px-3 py-2" />
        <input value={authCode} onChange={(e) => setAuthCode(e.target.value)} placeholder="验证码" className="w-full rounded-lg border border-border px-3 py-2" />
        {token ? (
          <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="新密码" className="w-full rounded-lg border border-border px-3 py-2" />
        ) : null}
        <button type="submit" className="w-full rounded-lg bg-primary py-2 text-white">{token ? '确认新密码' : '验证验证码'}</button>
      </form>
      {message ? <p className="text-sm text-muted">{message}</p> : null}
    </div>
  );
}
